/**
 * The only <img> in the codebase.
 *
 * Enforces the four things every image on the old site was missing:
 * lazy loading, async decoding, an explicit aspect-ratio box (so nothing
 * shifts while it loads), and a real alt string. `alt` is required —
 * pass `alt=""` deliberately for decorative images.
 */
const Image = ({
  src,
  alt,
  ratio = '3 / 2',
  priority = false,
  className = '',
  caption,
  ...rest
}) => {
  const frame = (
    <div className={`img-frame ${className}`} style={{ aspectRatio: ratio }}>
      {src && (
        <img
          className="img"
          src={src}
          alt={alt}
          loading={priority ? 'eager' : 'lazy'}
          decoding={priority ? 'sync' : 'async'}
          fetchpriority={priority ? 'high' : undefined}
          {...rest}
        />
      )}
    </div>
  );

  if (!caption) return frame;

  return (
    <figure>
      {frame}
      <figcaption className="img-caption">{caption}</figcaption>
    </figure>
  );
};

export default Image;
